var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-backdrop" }, [
    _c("div", { staticClass: "modal-dialog modal-lg" }, [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button", "aria-label": "Close" },
              on: { click: _vm.close }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
          _vm._v(" "),
          _c("h5", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.isEdit ? "Edit Embed" : "Create Embed"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.embed_id,
                      expression: "form.embed_id"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "embedId",
                    disabled: _vm.isEdit,
                    placeholder: "unique-embed-id",
                    required: ""
                  },
                  domProps: { value: _vm.form.embed_id },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "embed_id", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.isEdit
                  ? _c("small", { staticClass: "form-text text-muted" }, [
                      _vm._v("Embed ID cannot be changed after creation.")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _vm._v(
                    "This is displayed to users as the name of the dashboard."
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.name,
                      expression: "form.name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "name",
                    placeholder: "Dashboard Name",
                    required: ""
                  },
                  domProps: { value: _vm.form.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("Internal User UUIDs")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _vm._v(
                    "\n              Search for Goalbook Business users by name or email. Selected users can access this embed.\n            "
                  )
                ]),
                _vm._v(" "),
                _vm.usersLoading
                  ? _c("div", { staticClass: "text-muted small mt-1" }, [
                      _vm._v("Loading users...")
                    ])
                  : _c("div", { staticClass: "autocomplete-wrapper" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userSearchText,
                            expression: "userSearchText"
                          }
                        ],
                        staticClass: "form-control mb-1",
                        attrs: {
                          type: "text",
                          placeholder: "Search by name or email...",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.userSearchText },
                        on: {
                          focus: function($event) {
                            _vm.userDropdownOpen = true
                          },
                          blur: _vm.hideUserDropdown,
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.userSearchText = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.userDropdownOpen && _vm.filteredUsers.length > 0
                        ? _c(
                            "ul",
                            { staticClass: "autocomplete-dropdown" },
                            _vm._l(_vm.filteredUsers, function(user) {
                              return _c(
                                "li",
                                {
                                  key: user.uuid,
                                  staticClass: "autocomplete-item",
                                  on: {
                                    mousedown: function($event) {
                                      $event.preventDefault()
                                      return _vm.addUser(user)
                                    }
                                  }
                                },
                                [
                                  _c("strong", [_vm._v(_vm._s(user.name))]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(" - " + _vm._s(user.email))
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selected-chips",
                          attrs: { "aria-label": "Selected users" }
                        },
                        [
                          _vm._l(_vm.selectedUsers, function(user) {
                            return _c(
                              "span",
                              {
                                key: user.uuid,
                                staticClass: "badge badge-primary selected-chip"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      user.name || user.email || user.uuid
                                    ) +
                                    "\n                  "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "chip-remove",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        "Remove " + (user.name || user.uuid)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeUser(user)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-times" })]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.selectedUsers.length === 0
                            ? _c("span", { staticClass: "text-muted small" }, [
                                _vm._v("No users selected.")
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v("Domain UUIDs")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _vm._v(
                    "\n              Search for domains by name. Selected domains will have access to this embed.\n            "
                  )
                ]),
                _vm._v(" "),
                _vm.domainsLoading
                  ? _c("div", { staticClass: "text-muted small mt-1" }, [
                      _vm._v("Loading domains...")
                    ])
                  : _c("div", { staticClass: "autocomplete-wrapper" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.domainSearchText,
                            expression: "domainSearchText"
                          }
                        ],
                        staticClass: "form-control mb-1",
                        attrs: {
                          type: "text",
                          placeholder: "Search by domain name...",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.domainSearchText },
                        on: {
                          focus: function($event) {
                            _vm.domainDropdownOpen = true
                          },
                          blur: _vm.hideDomainDropdown,
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.domainSearchText = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.domainDropdownOpen && _vm.filteredDomains.length > 0
                        ? _c(
                            "ul",
                            { staticClass: "autocomplete-dropdown" },
                            _vm._l(_vm.filteredDomains, function(domain) {
                              return _c(
                                "li",
                                {
                                  key: domain.uuid,
                                  staticClass: "autocomplete-item",
                                  on: {
                                    mousedown: function($event) {
                                      $event.preventDefault()
                                      return _vm.addDomain(domain)
                                    }
                                  }
                                },
                                [_c("strong", [_vm._v(_vm._s(domain.name))])]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selected-chips",
                          attrs: { "aria-label": "Selected domains" }
                        },
                        [
                          _vm._l(_vm.selectedDomains, function(domain) {
                            return _c(
                              "span",
                              {
                                key: domain.uuid,
                                staticClass: "badge badge-info selected-chip"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(domain.name || domain.uuid) +
                                    "\n                  "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "chip-remove",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        "Remove " + (domain.name || domain.uuid)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeDomain(domain)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-times" })]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.selectedDomains.length === 0
                            ? _c("span", { staticClass: "text-muted small" }, [
                                _vm._v("No domains selected.")
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label",
                    attrs: { for: "schoolFieldName" }
                  },
                  [_vm._v("School Field Name")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.school_field_name,
                      expression: "form.school_field_name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "schoolFieldName",
                    placeholder: "Optional field name"
                  },
                  domProps: { value: _vm.form.school_field_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form,
                        "school_field_name",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _vm._v(
                    "If it's a custom board, sometimes it has a different field name for the school. We need to specify that here so the school filtering can work."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.active,
                          expression: "form.active"
                        }
                      ],
                      attrs: { type: "checkbox", id: "active" },
                      domProps: {
                        checked: Array.isArray(_vm.form.active)
                          ? _vm._i(_vm.form.active, null) > -1
                          : _vm.form.active
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.active,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.form, "active", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "active",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "active", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v("\n                Active\n              ")
                  ])
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _vm._v("Inactive embeds are hidden from end users.")
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button", "data-testid": "cancel-button" },
              on: { click: _vm.close }
            },
            [_vm._v("\n          Cancel\n        ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                type: "button",
                "data-testid": "save-button",
                disabled: _vm.saving
              },
              on: { click: _vm.save }
            },
            [
              _vm.saving
                ? _c("i", { staticClass: "fa fa-spinner fa-spin me-1" })
                : _vm._e(),
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.saving ? "Saving..." : _vm.isEdit ? "Update" : "Create"
                  ) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label", attrs: { for: "embedId" } },
      [
        _vm._v("Embed ID "),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-label", attrs: { for: "name" } }, [
      _vm._v("Name "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }